import React from "react";

import { ConfirmModal, IConfirmModalProps } from "@amphore-dev/amphore-lib";
import { t } from "i18next";
import { Trans } from "react-i18next";

export const UnsavedChangesModal: React.FC<IConfirmModalProps> = (props) => {
	return (
		<ConfirmModal
			title={t("edit.unsavedChanges.title", {}).toString()}
			confirmText={t("actions.leave").toString()}
			cancelText={t("actions.stay").toString()}
			className="[&_button]:w-auto"
			// Portaled: this opens from inside the sticky SidePanel (EditPanel),
			// whose stacking context would otherwise trap it under the page's
			// other sticky headers.
			portal
			{...props}
		>
			<Trans i18nKey="edit.unsavedChanges.message" />
		</ConfirmModal>
	);
};
